// Mirrors the backend's supported extension/MIME pairs (Videos::Uploads::Prepare).
export const VIDEO_UPLOAD_TYPES: Record<string, string> = {
  '.mp4': 'video/mp4',
  '.m4v': 'video/x-m4v',
  '.mov': 'video/quicktime',
  '.webm': 'video/webm',
};
export const VIDEO_UPLOAD_EXTENSIONS = Object.keys(VIDEO_UPLOAD_TYPES);
export const VIDEO_UPLOAD_ACCEPT = Object.values(VIDEO_UPLOAD_TYPES).join(',');
// Files larger than 100 MB upload as an S3 multipart session; files at or below use a
// single presigned PUT. Follows the Uppy/AWS guidance for the multipart cutover.
export const VIDEO_UPLOAD_MULTIPART_THRESHOLD_BYTES = 100 * 1024 * 1024;
